import { IGetGrupoAcessoUsuarioUseCase } from "../../../presentation/useCases/read/get_grupo_acesso_usuario_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";
import { BasePaginatedUseCase } from '../../../../../common/domain/useCases/base_paginated_use_case';
import { GrupoAcessoUsuario } from '../../models/grupo_acesso_usuario';

/**
 * GetGrupoAcessoUsuarioUseCase
 */

export class GetGrupoAcessoUsuarioUseCase extends BasePaginatedUseCase<GrupoAcessoUsuario>
  implements IGetGrupoAcessoUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) {
    super();
  }

  async execute(
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {

    const request = await this.repository.getGruposAcesso(
      page ?? 1,
      rowsPerPage ?? 100,
      null,
      null,
      null,
    );

    const normalizedItems: GrupoAcessoUsuario[] = request.items.map((item) => ({
      idGrupoAcesso: item.idGrupoAcesso ?? 0,
      grupo: item.nomeGrupo ?? undefined,
      descricao: item.descricao ?? undefined,
    }));

    this._items = normalizedItems;
    this._totalItems = request.totalItems;
    this._currentPage = request.currentPage;
    this._pageSize = request.pageSize;
    this._totalPages = request.totalPages;

  }
}
